export { default } from './Renegociacao25EmpCanais';
